module.exports = __webpack_public_path__ + "static/media/MuseoSansMedium.e1edf317.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansMedium/MuseoSansMedium.ttf
// module id = 643
// module chunks = 0